import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { EntityOrderedRequestParameters, EntityPagedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { JanelaAtualizacaoInformacoes } from "src/app/model/janelas-atualizacao-informacoes.model";
import { TIPOS_JANELA } from "src/app/model/janelas-atualizacao-informacoes.model";
import { JanelasAtualizacaoInformacoesService } from "../../janelas-atualizacao-informacoes.service";

@Component({
    selector: 'app-janelas-atualizacao-informacoes-listagem',
    templateUrl: './janelas-atualizacao-informacoes-listagem.html',
    standalone: false
})
export class JanelasAtualizacaoInformacoesListagemComponent {
    
    @Input() janelas: JanelaAtualizacaoInformacoes[];
    @Input() atributosPaginacao: EntityPagedRequestParameters;
    @Input() podeIncluirNovaJanela: boolean;
    @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();

    public opcoesPaginacao: number[] = [10, 15, 20];
    public atributosOrdenacao: EntityOrderedRequestParameters;

    constructor(
        private activatedRoute:ActivatedRoute,
        private janelasAtualizacaoInfoService: JanelasAtualizacaoInformacoesService
    ){}

    ngOnInit() {
      if (!this.atributosOrdenacao){
      this.atributosOrdenacao = {
        atributo: '',
        sentido: 'asc'
      }
    }
    }

    nomeTipoJanela(codigo): string {
      for (let tipo of TIPOS_JANELA) {
        if (tipo.codigo == codigo) {
          return tipo.label;
        }
      }
    }
    
    mudancaPagina(novaPagina: EntityPagedRequestParameters) {
        this.atributosPaginacao = novaPagina;
        this.aoMudarPagina.emit(novaPagina);
    }

    mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
        this.atributosOrdenacao = novaOrdenacao;
        this.pesquisarOrdenacao(this.atributosOrdenacao);
    }

    excluirJanela(id) {
      this.janelasAtualizacaoInfoService.excluir(id).subscribe(() => {
        let pos = 0;
        for (let janela of this.janelas) {
          if (janela.id == id) {
            this.janelas.splice(pos, 1);
            return;
          }
          pos++;
        }
      });
    }

    pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
        this.janelas = this.janelas.sort((a, b) => {
        if (ord.sentido == "asc") {
            return this.compara(a, b, ord.atributo);
        }
        else {
            return -1 * this.compara(a, b, ord.atributo);
        }
        });
    }
    
    private compara(a, b, atributo): number {
        if (this.fetchFromObject(a, atributo) == this.fetchFromObject(b, atributo)) {
          return 0;
        }
        else {
          if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
            return 1;
          }
          else {
            return -1;
          }
        }
    }

    private fetchFromObject(obj, prop) {

        if(typeof obj === 'undefined') {
          return false;
        }
    
        var _index = prop.indexOf('.')
        if(_index > -1) {
            return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
        }
    
        return obj[prop];
      }

      
}